import { useEffect, useState } from "react";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { check, request, PERMISSIONS, RESULTS } from "react-native-permissions";
import fetchCurrentLocation from "@utils/getCurrentLocation";

const MILLISECONDS_IN_SECONDS = 1000 * 60;

const useLocationHook = () => {
  const [coordinates, setCoordinates] = useState(null);

  const saveCoordinates = async (coords) => {
    try {
      await AsyncStorage.setItem(
        "userCoordinates",
        JSON.stringify({ ...coords, created_at: new Date() }),
      );
      setCoordinates({ ...coords, created_at: new Date() });
    } catch (error) {
      console.error("Error saving coordinates to storage:", error);
    }
  };

  const getCurrentLocation = async (timeout = 1) => {
    const value = await AsyncStorage.getItem("userCoordinates");
    const coords = JSON.parse(value);
    if (
      coords &&
      new Date() - new Date(coords.created_at) <
        MILLISECONDS_IN_SECONDS * timeout
    ) {
      return coords;
    }
    if (
      coordinates &&
      new Date() - new Date(coordinates.created_at) <
        MILLISECONDS_IN_SECONDS * timeout
    ) {
      return coordinates;
    }
    try {
      const position = await fetchCurrentLocation({ timeoutMs: 5000 });
      const { latitude, longitude } = position.coords;
      saveCoordinates({ latitude, longitude });
      return position.coords;
    } catch (error) {
      console.log("Error getting location:", error);
      return { latitude: null, longitude: null };
    }
  };

  const checkPermission = async () => {
    try {
      const result = await check(PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION);
      if (result === RESULTS.GRANTED) {
        await getCurrentLocation();
      } else if (result === RESULTS.DENIED) {
        const requestResult = await request(
          PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION,
        );
        if (requestResult === RESULTS.GRANTED) {
          await getCurrentLocation();
        } else {
          //   navigation.navigate(permissionDeniedScreen);
        }
      } else {
        // navigation.navigate(permissionDeniedScreen);
      }
    } catch (error) {
      console.error("Permission check error:", error);
    }
  };

  useEffect(() => {
    checkPermission();
  }, []);

  return getCurrentLocation;
};

export default useLocationHook;
